import locales from 'data/locales/locales';

const isDefaultLocale = (locale) => locales[locale].default;

export default isDefaultLocale;
